module.exports = __webpack_public_path__ + "img/twitter.3c5e9fd4.svg";